import { Injectable } from "@angular/core";
import { Platform } from "ionic-angular";
import { Device } from "@ionic-native/device";

export const APP_PLATFORM_THIRD = false; //是否运行在第三方平台
export const THIRD_PAGE = "ApprovalPage"; //第三方集成默认地址

// export let ENVIRONMENT = 'debug';//无接口数据 使用mock
export let ENVIRONMENT = "development"; //开发
// export let ENVIRONMENT = 'production';//生产

export const USETOKENAUTHEN = true; //是否使用token认证每一个接口

export const SYS_SERVICE_URL = {
  debug_base_url: "assets/mock/", //debug
  base_url: "api/", //新和成打包
  // base_url: "http://192.168.1.182:8889/", //新和成测试
  i18n_base_url: "assets/mock/", //国际化文件
  upgrade_base_url: "https://esd.neusoft.com/", //版本更新地址
  chat_base_url: "https://10.20.14.115:443/", //聊天服务地址
};

export const FIND_RECORD_PAGE = {
  "10": "TravelExpensePage",
  "12": "TravelExpensePage",
  "15": "CommunicationEditPage",
  "20": "LivingExpensesPage",
  "21": "EntertainEditPage",
  "40": "LoanEditPage",
  "41": "RepaymentEditPage",
  "202": "TravelApplyPage",
  "618": "PricarExpensePage",
};

/** 需要缓存的全局数据 */
export const BIZ_CACHE_TABLE: Array<any> = [
  {
    // 字典
    doc_id: "codeList", //与CACHE_TABLE_VERSION对应的key
    interface_method: "QUERY_CODELIST", //接口key
    local_key: "_SYS_CODELIST", //本地存储的key
    global_key: "codelist", //global.state中的key
    cache_flag: true, //是否缓存
  },
  {
    // 单据类型
    doc_id: "ecClaimType",
    interface_method: "QUERY_DOCKIND",
    local_key: "_SYS_DOCKIND",
    global_key: "claimTypes",
    cache_flag: true,
  },
  {
    // 地区
    doc_id: "mdDistrict",
    interface_method: "QUERY_MDCITYS",
    local_key: "_SYS_AREADATAS",
    global_key: "mdDistrict",
    cache_flag: true,
  },
];

@Injectable()
export class AppConfiguration {
  constructor(private platform: Platform, private device: Device) {}

  /**
   * 获取应用版本号
   */
  getAppVersion() {
    return this.platform.version();
  }

  /**
   * 获取平台信息
   * android：安卓平台
   * ios：ios平台
   * windows：浏览器
   */
  getPlatform() {
    let platform = "windows";
    this.platform.is("ios") && (platform = "ios");
    this.platform.is("android") && (platform = "android");
    this.platform.is("mobileweb") && (platform = "windows");
    return platform;
  }

  /**
   * 获取设备UUID 浏览器为“1234567890-liulanqi”
   */
  getUUID(): string {
    return this.device.uuid || "1234567890-liulanqi";
  }
}



// WEBPACK FOOTER //
// ./src/config/app.config.ts